 <template>
  <div style="padding-top: 30px;">
    <div style="text-align:center;">
      <img src="https://img.nzmai.com.cn/ieMall_logo.png" alt="IeMall" class="logo" />
      <h2>ieMall Mobile Admin System</h2>
    </div>
    <div>
      <van-cell-group>
        <van-field v-model="username" required clearable label="Username" placeholder="Username" />
        <van-field
          v-model="password"
          type="password"
          label="Password "
          placeholder="Password "
          required
        />
      </van-cell-group>
    </div>
    <div class="agree">
      <van-checkbox checked-color="#07c160" bind:change="onChange" v-model="checked">
        <a
          href="https://img.nzmai.com.cn/IE%20MALL%20Free%20user%20%20MERCHANT%20AGREEMENT.pdf"
          target="blank"
        >ieMall Merchant's Agreement</a>
      </van-checkbox>&nbsp;
      <van-tag v-on:click="clickInfo">?</van-tag>
      <!-- <input type="checkbox" v-model="checked" class="checkbox"> -->
      <!-- <a href="https://img.nzmai.com.cn/IEMALLFreeuserMERCHANTAGREEMENT.pdf" target="blank">&nbsp;&nbsp;ieMall Merchant's Agreement</a> -->
    </div>
    <div style="margin:10px;">
      <van-button type="primary" size="large" @click="submit" :loading="buttonLoading">Sign in</van-button>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  Row,
  Col,
  Button,
  Checkbox,
  Tag,
  Dialog
} from 'vant'
import { Toast } from 'vant'

export default {
  name: 'login',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      username: '',
      password: '',
      buttonLoading: false,
      checked: true
    }
  },
  methods: {
    submit() {
      if (this.checked === true) {
        this.$store
          .dispatch('Login', {
            username: this.username,
            password: this.password
          })
          .then(() => {
            this.loading = false
            this.$router.push({ path: '/' })
          })
          .catch(async(err) => {
            this.loading = false
            if (!err) {
              err = 'Wrong username or password!'
            }
            Toast.fail(err)
          })
      } else {
        Toast.fail(
          'You must agree terms & conditions in order to use iemall service!'
        )
      }
    },
    clickInfo() {
      Dialog.alert({
        message:
          'By ticking the "I Agree" button on the website, prospective IE Mall Merchants who do not have a paying agreement consent and agree to the terms and conditions in the IE Mall Standard Merchant Agreement, and a copy of which is on the website',
        confirmButtonText: 'Confirm'
      }).then(() => {
        // on close
      })
    }
  }
}
</script>

<style scoped lang="less">
.logo {
  width: 30%;
  margin-bottom: 10px;
}
.agree {
  width: 100%;
  font-size: 13px;
  display: inline-flex;
  justify-content: center;
  margin: 20px auto;
  a {
    text-decoration: underline;
    color: #888484;
  }
}
.checkbox {
  font-size: 20px;
}
</style>
<style type="text/css">
.van-field__control {
  line-height: 24px !important;
}
</style>
